<template>
  <div>
    <div @click="showPopup" style="width: 100%">
      <CommonInput
        v-model="currentValue"
        type="text"
        :placeholder="placeholder"
        :class="[$store.state.isMirroring && 'mirror']"
        theme="white"
        readonly
      >
        <img class="arrow" :class="[$store.state.isMirroring && 'mirror']" src="@/assets/back_new.png" alt="back" />
      </CommonInput>
    </div>
    <LinkAccountSelect
      v-model="show"
      :list="bankCodesList"
      :index-list="indexList"
      :on-select="selectItem"
      :onShow="(val) => (show = val)"
      show-text="bankName"
    />
  </div>
</template>

<script type="module">
import Tabbar from '@/components/Tabbar.vue'
import CommonInput from '@/components/CommonInput.vue'
import Vue from 'vue'
import { IndexBar, IndexAnchor } from 'vant'
import LinkAccountSelect from '@/components/LinkAccount/Select'

Vue.use(IndexBar)
Vue.use(IndexAnchor)

export default {
  name: 'SelectBankCode',
  components: {
    Tabbar,
    CommonInput,
    LinkAccountSelect
  },
  data() {
    return {
      currentValue: '',
      show: false,
      bankCodesList: [],
      indexList: []
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    placeholder: String
  },
  watch: {
    '$attrs.value': function (value) {
      this.currentValue = value.bankName
    }
  },
  mounted() {
    this.getBankAccountList()
  },
  methods: {
    getBankAccountList() {
      this.$http
        .get(window.serverPath + '/api/country/getBackCordList?countryNo=' + this.$store.state.userInfo.countryNo)
        .then((res) => {
          if (res.data.code === '200' && res.data) {
            console.log(res.data.data, 999)
            this.bankCodesList = res.data.data || []
            this.prepareData()
          }
        })
        .catch((_err) => {
          console.log('异常')
        })
    },
    showPopup() {
      this.show = true
    },
    onBack() {
      this.show = false
    },
    prepareData() {
      const indexList = []
      for (let item of this.bankCodesList) {
        indexList.push(item.type)
      }
      this.indexList = indexList
    },
    selectItem(value) {
      this.currentValue = value.bankName
      this.show = false
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
.select-bank-wrapper {
  width: 100%;
}

.select_account_arrow_img {
  width: 0.12rem;
  height: 0.12rem;
  transform: rotateY(180deg);
}

.select_account_arrow_img.mirror {
  transform: none;
}

.select_bank_popup {
  width: 100%;
  height: 100%;
  background: #fff;
}

.arrow {
  width: 0.12rem;
  height: 0.12rem;
  transform: rotateY(180deg);
}

.arrow.mirror {
  transform: none;
}
</style>

<style>
.select-bank-wrapper .van-index-anchor {
  background: #eef1f7;
  height: 0.3rem;
  padding-left: 0.24rem;
  color: #000d23;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectBankCode.vue